import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({
    // 团状态
    GROUP_STATUS_IS_OK: 2, //拼单成功
    GROUP_STATUS_IS_FAIL: 3, //拼单失败
    GROUP_STATUS_IS_PENDING: 1, //拼单中
    // 订单类型for 后端
    PREORDER_ORDER_TYPE_FOR_PAY_NORMAL: 0,
    PREORDER_ORDER_TYPE_FOR_PAY_GROUPON: 2,
    PREORDER_ORDER_TYPE_FOR_PAY_QIYEGOU: 4, // 用于企业购下单的类型
    // 订单类型for 前端 
    PREORDER_ORDER_TYPE_NORMAL: 1,
    PREORDER_ORDER_TYPE_GROUPON: 4,

    ACTIVITY_MAX_GROUP_LENGTH: 5,
    GROUP_INSTRUCTIONS_URL: 'https://m.sdyxmall.com/act/active/MkeMzQ936324', //团购详细说明地址
    GROUP_ACTION_PARAM: 1, //分享跳转至actionData param=1 非1跳转act uu group
}, km({
    ITEM_GET_GROUP_INFO_SUCCESS: null, //获取正在拼团人数和团需要人数
    ITEM_GET_GROUP_INFO_ERROR: null,


    ITEM_GET_HOT_ACTIVE_GROUP_LIST_SUCCESS: null,
    ITEM_GET_HOT_ACTIVE_GROUP_LIST_ERROR: null,

    ITEM_GETMOREGROUP_SUCCESS: null,
    ITEM_GETMOREGROUP_ERROR: null,

    ITEM_GET_GROUP_USER_SUCCESS: null,
    ITEM_GET_GROUP_USER_ERROR: null,


}))
